export default __webpack_public_path__ + "static/media/lemontbotanique_logo.5df4eb5d.svg";